// extracted by mini-css-extract-plugin
export default {"root":"DishesTableHeader_root__+KNWs","cell":"DishesTableHeader_cell__9rPu8","placeHolderShimmer":"DishesTableHeader_placeHolderShimmer__RsMvR"};